import { WEBSITE_URL } from "./website";

export const GET_SETTINGS_URL = WEBSITE_URL + "/api/get-settings";
export const SEARCH_LOCATIONS_URL = WEBSITE_URL + "/api/search-location";
export const GET_POPULAR_LOCATIONS_URL = WEBSITE_URL + "/api/popular-geo-locations";
export const GET_PROMO_SLIDER_URL = WEBSITE_URL + "/api/promo-slider";
export const GET_DELIVERY_RESTAURANTS_URL = WEBSITE_URL + "/api/get-delivery-restaurants";
export const GET_SELFPICKUP_RESTAURANTS_URL = WEBSITE_URL + "/api/get-selfpickup-restaurants";
export const GET_TABLE_RESTAURANTS_URL = WEBSITE_URL + "/api/get-table-restaurants";
export const GET_RESTAURANT_INFO_URL = WEBSITE_URL + "/api/get-restaurant-info";
export const GET_RESTAURANT_INFO_BY_ID_URL = WEBSITE_URL + "/api/get-restaurant-info-by-id";
export const GET_RESTAURANT_INFO_AND_OPERATIONAL_STATUS_URL =
	WEBSITE_URL + "/api/get-restaurant-info-and-operational-status";

// Spot Management
export const GET_SPOT_ORDERS_URL = WEBSITE_URL + "/api/get-orders";
export const GET_SPOTPICKUP_RESTAURANTS_URL = WEBSITE_URL + "/api/get-spotpickup-restaurants";
export const GET_RESTAURANT_SPOTS_URL = WEBSITE_URL + "/api/get-restaurant-spots";
export const GET_SPOTS_URL = WEBSITE_URL + "/api/get-spots-orders";
export const PLACE_SPOT_ORDER_URL = WEBSITE_URL + "/api/place--spot-order";
export const GET_SPOT_ORDER_CANCEL_URL = WEBSITE_URL + "/api/cancel-spot-order";
export const CHECK_USER_RUNNING_SPOT_ORDER_URL = WEBSITE_URL + "/api/check-running-spot-order";
export const CHECK_CART_SPOTS_AVAILABILITY_URL = WEBSITE_URL + "/api/check-cart-spots-availability";
export const PICKEDUP_SPOT_ORDER_URL = WEBSITE_URL + "/api/delivery/pickedup-spot-order";
export const GET_SINGLE_SPOT_URL = WEBSITE_URL + "/api/get-single-spot";
export const GET_SINGLE_SPOT_ORDER_TO_BE_RATED = WEBSITE_URL + "/api/single-ratable-spot-order";
export const GET_RATABLE_SPOT_ORDER_DETAILS_URL = WEBSITE_URL + "/api/get-ratable-spot-order";
export const ADD_SPOT_RATING_URL = WEBSITE_URL + "/api/save-new-spot-rating";



export const GET_RESTAURANT_ITEMS_URL = WEBSITE_URL + "/api/get-restaurant-items";
export const APPLY_COUPON_URL = WEBSITE_URL + "/api/apply-coupon";
export const LOGIN_USER_URL = WEBSITE_URL + "/api/login";
export const REGISTER_USER_URL = WEBSITE_URL + "/api/register";
export const SUBMIT_USER_MSG_URL = WEBSITE_URL + "/api/submit-message";
export const GET_PAGES_URL = WEBSITE_URL + "/api/get-pages";
export const GET_SINGLE_PAGE_URL = WEBSITE_URL + "/api/get-single-page";
export const SEARCH_RESTAURANTS_URL = WEBSITE_URL + "/api/search-restaurants";
export const GET_ADDRESSES_URL = WEBSITE_URL + "/api/get-addresses";
export const SAVE_ADDRESS_URL = WEBSITE_URL + "/api/save-address";
export const DELETE_ADDRESS_URL = WEBSITE_URL + "/api/delete-address";
export const GET_CARDS_URL = WEBSITE_URL + "/api/get-cards";
export const SAVE_CARD_URL = WEBSITE_URL + "/api/save-card";
export const DELETE_CARD_URL = WEBSITE_URL + "/api/delete-card";
export const SET_DEFAULT_CARD_URL = WEBSITE_URL + "/api/set-default-card";
export const UPDATE_USER_INFO_URL = WEBSITE_URL + "/api/update-user-info";
export const CHANGE_USER_AVATAR_URL = WEBSITE_URL + "/api/change-avatar";
export const CHECK_BAN_URL = WEBSITE_URL + "/api/check-ban";
export const PLACE_ORDER_URL = WEBSITE_URL + "/api/place-order";
export const SET_DEFAULT_URL = WEBSITE_URL + "/api/set-default-address";
export const GET_ORDERS_URL = WEBSITE_URL + "/api/get-orders";
export const GET_PAYMENT_GATEWAYS_URL = WEBSITE_URL + "/api/get-payment-gateways";
export const NOTIFICATION_TOKEN_URL = WEBSITE_URL + "/api/save-notification-token";
export const SEND_OTP_URL = WEBSITE_URL + "/api/send-otp";
export const VERIFY_OTP_URL = WEBSITE_URL + "/api/verify-otp";
export const RAZORPAY_PAYMENT_URL = WEBSITE_URL + "/api/payment/process-razor-pay";
export const PAYTM_PAYMENT_URL = WEBSITE_URL + "/api/payment/paytm";
export const CHECK_USER_RUNNING_ORDER_URL = WEBSITE_URL + "/api/check-running-order";
export const GET_ORDER_CANCEL_URL = WEBSITE_URL + "/api/cancel-order";
export const GET_WALLET_TRANSACTIONS_URL = WEBSITE_URL + "/api/get-wallet-transactions";
export const CHECK_RESTAURANT_OPERATION_SERVICE_URL = WEBSITE_URL + "/api/check-restaurant-operation-service";
export const GET_SINGLE_ITEM_URL = WEBSITE_URL + "/api/get-single-item";
export const GET_ALL_LANGUAGES_URL = WEBSITE_URL + "/api/get-all-languages";
export const GET_SINGLE_LANGUAGE_DATA_URL = WEBSITE_URL + "/api/get-single-language";
export const GET_ADDRESS_FROM_COORDINATES = WEBSITE_URL + "/api/coordinate-to-address";
export const SEND_PASSWORD_RESET_EMAIL_URL = WEBSITE_URL + "/api/send-password-reset-mail";
export const VERIFY_PASSWORD_RESET_OTP_URL = WEBSITE_URL + "/api/verify-password-reset-otp";
export const CHANGE_USER_PASSWORD_URL = WEBSITE_URL + "/api/change-user-password";
export const GET_RESTAURANTS_CATEGORIES_URL = WEBSITE_URL + "/api/get-all-restaurants-categories";
export const GET_FILTERED_RESTAURANTS_URL = WEBSITE_URL + "/api/get-filtered-restaurants";
export const GET_RESTAURANTS_SLIDES_URL = WEBSITE_URL + "/api/get-restaurant-category-slides";
export const GET_SUB_CATEGORIES_URL = WEBSITE_URL + "/api/get-sub-categories";
export const GET_FILTERED_RESTAURANTS_AND_ITEMS_URL = WEBSITE_URL + "/api/get-filtered-restaurants-and-items";
export const GET_ALERTS_URL = WEBSITE_URL + "/api/get-user-notifications";
export const MARK_ALL_NOTIFICATIONS_READ_URL = WEBSITE_URL + "/api/mark-all-notifications-read";
export const MARK_ONE_NOTIFICATION_READ_URL = WEBSITE_URL + "/api/mark-one-notification-read";
export const CHECK_CART_ITEMS_AVAILABILITY_URL = WEBSITE_URL + "/api/check-cart-items-availability";


export const STRIPE_PAYMENT = WEBSITE_URL + "/api/accept-stripe-payment";
export const STRIPE_PAYMENT_CAPTURE = WEBSITE_URL + "/api/stripe-redirect-capture";
export const PAYMONGO_PAYMENT_URL = WEBSITE_URL + "/api/payment/process-paymongo";
export const MERCADOPAGO_PAYMENT_URL = WEBSITE_URL + "/api/payment/process-mercado-pago";
export const TRANZILA_PAYMENT_URL = WEBSITE_URL + "/api/payment/process-tranzila";
export const TRANZILA_DEBIT_URL = WEBSITE_URL + "/api/payment/tranzila/debit";
export const ZCREDIT_PAYMENT_URL = WEBSITE_URL + "/api/payment/process-zcredit";
export const MCREDIT_PAYMENT_URL = WEBSITE_URL + "/api/payment/process-mcredit";
export const GET_SINGLE_ORDER_TO_BE_RATED = WEBSITE_URL + "/api/single-ratable-order";
export const GET_RATABLE_ORDER_DETAILS_URL = WEBSITE_URL + "/api/get-ratable-order";
export const ADD_RATING_URL = WEBSITE_URL + "/api/rate-order";
export const SAVE_VAT_NUMBER_URL = WEBSITE_URL + "/api/update-tax-number";

export const LOGIN_USER_WITH_OTP_URL = WEBSITE_URL + "/api/login-with-otp";
export const GENERATE_OTP_FOR_LOGIN_URL = WEBSITE_URL + "/api/generate-otp-for-login";

/* Delivery URLs */
export const LOGIN_DELIVERY_USER_URL = WEBSITE_URL + "/api/delivery/login";
export const UPDATE_DELIVERY_USER_INFO_URL = WEBSITE_URL + "/api/delivery/update-user-info";
export const GET_DELIVERY_ORDERS_URL = WEBSITE_URL + "/api/delivery/get-delivery-orders";
export const GET_SINGLE_DELIVERY_ORDER_URL = WEBSITE_URL + "/api/delivery/get-single-delivery-order";
export const SEND_DELIVERY_GUY_GPS_LOCATION_URL = WEBSITE_URL + "/api/delivery/set-delivery-guy-gps-location";
export const GET_DELIVERY_GUY_GPS_LOCATION_URL = WEBSITE_URL + "/api/delivery/get-delivery-guy-gps-location";
export const ACCEPT_TO_DELIVER_URL = WEBSITE_URL + "/api/delivery/accept-to-deliver";
export const PICKEDUP_ORDER_URL = WEBSITE_URL + "/api/delivery/pickedup-order";
export const DELIVER_ORDER_URL = WEBSITE_URL + "/api/delivery/deliver-order";
export const DELIVERY_COMPLETED_ORDERS_URL = WEBSITE_URL + "/api/delivery/get-completed-orders";

/* 2.8.1 */
export const GET_REVIEWS_OF_STORE_URL = WEBSITE_URL + "/api/get-store-reviews";
export const ADD_TO_FAVORITE_RESTAURANT_URL = WEBSITE_URL + "/api/toggle-favorite";
export const GET_FAVORITE_RESTAURANTS_URL = WEBSITE_URL + "/api/get-favorite-stores";
export const GET_FAVORITE_RESTAURANT_FOR_LOGGED_IN_URL = WEBSITE_URL + "/api/get-restaurant-info-with-favourite";
export const TOGGLE_DELIVERY_GUY_STATUS_URL = WEBSITE_URL + "/api/delivery/toggle-delivery-guy-status";


/*3.5.0 */
export const ADMIN_LOGIN_AS_CUSTOMER_URL = WEBSITE_URL + "/callandorder/login-as-customer";
export const REGISTER_GUEST_USER_URL = WEBSITE_URL + "/callandorder/register-guest-user";

/* POS (PosCore) — all POST, JWT token in body */
export const POS_LOGIN_URL = WEBSITE_URL + "/api/pos/login";
export const POS_PLATFORM_CONFIG_URL = WEBSITE_URL + "/api/pos/platform/config";
export const POS_SWITCH_STORE_URL = WEBSITE_URL + "/api/pos/platform/switch-store";
export const POS_CATALOG_CATEGORIES_URL = WEBSITE_URL + "/api/pos/catalog/categories";
export const POS_CATALOG_TOP_URL = WEBSITE_URL + "/api/pos/catalog/top";
export const POS_CATALOG_ITEMS_URL = WEBSITE_URL + "/api/pos/catalog/items";
export const POS_CATALOG_SEARCH_URL = WEBSITE_URL + "/api/pos/catalog/items/search";
export const POS_CATALOG_ITEM_URL = WEBSITE_URL + "/api/pos/catalog/items"; // + `/${id}`
export const POS_ORDERS_URL = WEBSITE_URL + "/api/pos/orders";
export const POS_ORDER_CREATE_URL = WEBSITE_URL + "/api/pos/orders/create";
export const POS_ORDER_CANCEL_URL = WEBSITE_URL + "/api/pos/orders"; // + `/${id}/cancel`
export const POS_PRINTERS_URL = WEBSITE_URL + "/api/pos/printers";
export const POS_PRINTER_CREATE_URL = WEBSITE_URL + "/api/pos/printers/create";
export const POS_PRINTER_BASE_URL = WEBSITE_URL + "/api/pos/printers"; // + `/${id}/update|delete|test-print`
/* PosMultiPOS — terminals */
export const POS_TERMINALS_URL = WEBSITE_URL + "/api/pos/terminals";
export const POS_TERMINAL_CLAIM_URL = WEBSITE_URL + "/api/pos/terminals/claim";
export const POS_TERMINAL_BASE_URL = WEBSITE_URL + "/api/pos/terminals"; // + `/${id}/approve|revoke|assign-printer`
/* PosCashRegister */
export const POS_CR_SESSION_URL = WEBSITE_URL + "/api/pos/cash-register/session";
export const POS_CR_OPEN_URL = WEBSITE_URL + "/api/pos/cash-register/session/open";
export const POS_CR_CLOSE_URL = WEBSITE_URL + "/api/pos/cash-register/session/close";
export const POS_CR_CASH_IN_OUT_URL = WEBSITE_URL + "/api/pos/cash-register/cash-in-out";
export const POS_CR_TRANSACTIONS_URL = WEBSITE_URL + "/api/pos/cash-register/transactions";
/* ZCredit card payments */
export const POS_PAYMENT_CHARGE_URL = WEBSITE_URL + "/api/pos/payments/charge";
export const POS_PAYMENT_CHARGE_LEG_URL = WEBSITE_URL + "/api/pos/payments/charge-leg";
export const POS_PAYMENT_RELEASE_PINPAD_URL = WEBSITE_URL + "/api/pos/payments/release-pinpad";
export const POS_ORDER_REFUND_URL = WEBSITE_URL + "/api/pos/orders"; // + `/${id}/refund`
/* Refunds — scan the receipt barcode, credit lines back to card or cash */
export const POS_ORDER_LOOKUP_URL = WEBSITE_URL + "/api/pos/orders/lookup";
export const POS_REFUNDS_URL = WEBSITE_URL + "/api/pos/refunds";
export const POS_REFUND_CREATE_URL = WEBSITE_URL + "/api/pos/refunds/create";
/* PosInventory */
export const POS_INVENTORY_DASHBOARD_URL = WEBSITE_URL + "/api/pos/inventory/dashboard";
export const POS_INVENTORY_ITEMS_URL = WEBSITE_URL + "/api/pos/inventory/items";
export const POS_INVENTORY_MOVEMENTS_URL = WEBSITE_URL + "/api/pos/inventory/movements";
export const POS_INVENTORY_ADJUST_URL = WEBSITE_URL + "/api/pos/inventory/adjust";
/* PosTableReservation — operator console */
export const POS_TABLES_AREAS_URL = WEBSITE_URL + "/api/pos/tables/areas";
export const POS_TABLES_AREA_CREATE_URL = WEBSITE_URL + "/api/pos/tables/areas/create";
export const POS_TABLES_AREA_BASE_URL = WEBSITE_URL + "/api/pos/tables/areas"; // + `/${id}/update|delete`
export const POS_TABLES_URL = WEBSITE_URL + "/api/pos/tables";
export const POS_TABLES_STATUS_URL = WEBSITE_URL + "/api/pos/tables/status";
export const POS_TABLES_CREATE_URL = WEBSITE_URL + "/api/pos/tables/create";
export const POS_TABLES_BASE_URL = WEBSITE_URL + "/api/pos/tables"; // + `/${id}/update|delete|qr`
export const POS_RESERVATION_SETTINGS_URL = WEBSITE_URL + "/api/pos/reservations/settings";
export const POS_RESERVATION_SETTINGS_UPDATE_URL = WEBSITE_URL + "/api/pos/reservations/settings/update";
export const POS_RESERVATIONS_TODAY_URL = WEBSITE_URL + "/api/pos/reservations/today";
export const POS_RESERVATION_BASE_URL = WEBSITE_URL + "/api/pos/reservations"; // + `/${id}/confirm|cancel`
export const POS_WAITERS_URL = WEBSITE_URL + "/api/pos/waiters";
export const POS_WAITER_CREATE_URL = WEBSITE_URL + "/api/pos/waiters/create";
export const POS_WAITER_BASE_URL = WEBSITE_URL + "/api/pos/waiters"; // + `/${id}/update|delete`
export const POS_WAITER_REQUESTS_URL = WEBSITE_URL + "/api/pos/waiter-requests";
export const POS_WAITER_REQUEST_BASE_URL = WEBSITE_URL + "/api/pos/waiter-requests"; // + `/${id}/done`

/* Register quick panel — favourite groups, drill-down folders, open item */
export const POS_QUICK_LAYOUT_URL = WEBSITE_URL + "/api/pos/quick/layout";
export const POS_QUICK_GROUP_SAVE_URL = WEBSITE_URL + "/api/pos/quick/groups/save";
export const POS_QUICK_GROUP_BASE_URL = WEBSITE_URL + "/api/pos/quick/groups"; // + `/${id}/delete`
export const POS_QUICK_ITEM_SAVE_URL = WEBSITE_URL + "/api/pos/quick/items/save";
export const POS_QUICK_ITEM_BASE_URL = WEBSITE_URL + "/api/pos/quick/items"; // + `/${id}/delete`
export const POS_QUICK_REORDER_URL = WEBSITE_URL + "/api/pos/quick/reorder";

/* Counter-only custom items (POS-created, hidden from the app unless opted in) */
export const POS_CUSTOM_ITEMS_URL = WEBSITE_URL + "/api/pos/custom-items";
export const POS_CUSTOM_ITEM_SAVE_URL = WEBSITE_URL + "/api/pos/custom-items/save";
export const POS_CUSTOM_ITEM_BASE_URL = WEBSITE_URL + "/api/pos/custom-items"; // + `/${id}/delete`

/* Table booking — customer (tuk.to) */
export const TABLES_AREAS_URL = WEBSITE_URL + "/api/tables/areas";
export const TABLES_AVAILABILITY_URL = WEBSITE_URL + "/api/tables/availability";
export const TABLES_HOLD_URL = WEBSITE_URL + "/api/tables/hold";
export const TABLES_BOOK_URL = WEBSITE_URL + "/api/tables/book";
export const TABLES_RESOLVE_URL = WEBSITE_URL + "/api/tables/resolve";